import React from 'react';
import { Link } from 'react-router-dom';

const HelpSection = ({ header, text, image, to, target }) => {
  return (
    <div className="help-section-content">
      <Link
        to={to}
        className={to === '' ? 'non-clickable' : 'clickable'}
        target={target ? target : '_self'}
      >
        <img src={image} alt={header} />
        <div className="bottom-wrapper">
          <span className="home-help-header">{header}</span>
          <span className="home-text-two">{text}</span>
        </div>
      </Link>
    </div>
  );
};

export default HelpSection;
